import { render, staticRenderFns } from "./BlockImagesGallery.vue?vue&type=template&id=2c543b45&"
import script from "./BlockImagesGallery.vue?vue&type=script&lang=js&"
export * from "./BlockImagesGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports